import { cn } from "@/lib/utils"
import { Link } from "@tanstack/react-router"

export function PillarsBetaLogo({ white = false }: { white?: boolean }) {
  return (
    <Link
      className={cn("flex gap-2 items-end text-primary", white && "text-white")}
      to="/"
    >
      <div className="font-medium mt-1 text-3xl md:text-4xl">
        Pillars Speaker
      </div>
      <div className="opacity-50 italic mb-[1px]">BETA</div>
    </Link>
  )
}
